import { Link } from "react-router-dom";

export default function TechPromSection() {
  return (
    <section className="p-4 py-12 bg-secondary">
      <div className="container flex flex-col-reverse items-center md:flex-row gap-6 lg:gap-10 mx-auto max-w-7xl">
        <div className="flex flex-col items-center gap-4 md:items-start text-center md:w-[40%] md:text-left">
          <p className="text-primary uppercase border-2 border-primary px-8 py-1 rounded-full mb-4 md:mb-6">
            trending
          </p>
          <h2 className="uppercase text-primary font-bold text-[clamp(2rem,1.714rem+1.429vw,3rem)] leading-tight">
            the tech prom
          </h2>
          <p>
            A DINNER STYLE EVENT hosted by the Tech Space Community to bring
            together young, creative, and skilled people in tech — developers,
            designers, business owners, and digital creators for a UNIQUE TECH
            EXPERIENCE.
          </p>
          <Link
            to="#"
            className="w-full px-10 py-3 font-semibold text-center rounded-full sm:w-fit text-secondary bg-primary hover:opacity-90"
          >
            View
          </Link>
        </div>

        <div className="md:w-[60%]">
          <img
            src="/images/prom.jpg"
            alt="The Tech Prom"
            loading="lazy"
            className="max-w-full md:max-w-[60%] h-auto object-cover w-full rounded-2xl aspect-square mx-auto"
          />
        </div>
      </div>
    </section>

  )
}